import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Heart, Check } from "lucide-react";
import { api } from "@/lib/api";

export const WinBack = () => {
  const [days, setDays] = useState(60);
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get("/win-back", { params: { days } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [days]);
  useEffect(() => { load(); }, [load]);

  const send = async (r) => {
    window.open(r.whatsapp_url, "_blank");
    await api.post(`/win-back/${r.customer_id}/sent`);
    load(); toast.success("Ucapan win-back dibuka di WhatsApp");
  };

  return (
    <section className="mt-8" data-testid="win-back">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2">
        <Heart size={16} className="text-lm-red" /> Ajak Kembali (Win Back)
        {data?.rows?.length > 0 && <span data-testid="win-back-count" className="text-[11px] px-2 py-0.5 rounded-full bg-lm-red text-white">{data.rows.length}</span>}
      </h2>
      <p className="mt-1 text-sm text-ink-soft">
        Pelanggan yang sudah lama tidak menyewa — kirim ucapan plus voucher{" "}
        <span className="text-ink font-semibold">{data?.promo_code || "—"}</span> (gratis ongkir).
        Ubah kode &amp; isi pesannya di Settings.
      </p>

      <div className="mt-3 flex flex-wrap gap-2">
        {[30, 60, 90, 180].map((d) => (
          <button key={d} data-testid={`wb-days-${d}`} onClick={() => setDays(d)}
            className={`text-xs px-3 py-2 rounded-full border ${days === d ? "bg-ink text-cream border-ink" : "border-black/15"}`}>
            {d}+ hari
          </button>
        ))}
      </div>

      <div className="mt-3 space-y-3">
        {(data?.rows || []).map((r) => (
          <div key={r.customer_id} className="bg-white border border-black/10 rounded-lg p-4" data-testid={`wb-row-${r.customer_id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="min-w-0">
                <div className="text-sm font-semibold">{r.name} · {r.whatsapp}</div>
                <div className="text-xs text-ink-soft mt-0.5">
                  Terakhir sewa {r.last_rental} · {r.days_idle} hari tidak aktif · {r.total_rentals}x sewa · {r.tier}
                </div>
                {r.sent_at && <div className="mt-1 text-[11px] text-emerald-700 inline-flex items-center gap-1"><Check size={12} /> pernah dikirim {r.sent_at.slice(0, 10)}</div>}
              </div>
              <button data-testid={`wb-send-${r.customer_id}`} onClick={() => send(r)}
                className="lm-btn-primary rounded-md px-4 py-2.5 text-sm font-semibold inline-flex items-center gap-2">
                <MessageCircle size={15} /> Kirim Ajakan
              </button>
            </div>
            <pre className="mt-3 whitespace-pre-wrap font-sans text-xs text-ink-soft border-t border-black/5 pt-3">{r.message}</pre>
          </div>
        ))}
        {data && data.rows.length === 0 && (
          <div className="bg-white border border-black/10 rounded-lg p-5 text-sm text-ink-soft" data-testid="win-back-empty">
            Tidak ada pelanggan yang menganggur lebih dari {days} hari. Bagus!
          </div>
        )}
      </div>
    </section>
  );
};
